export default "__VITE_ASSET__CYIqZs0a__"